import { render, staticRenderFns } from "./VideoUpload2.vue?vue&type=template&id=1c20e876&scoped=true"
import script from "./VideoUpload2.vue?vue&type=script&lang=js"
export * from "./VideoUpload2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c20e876",
  null
  
)

export default component.exports